import { Component, DestroyRef, ElementRef, EventEmitter,OnInit,Output,inject,viewChild,} from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators,} from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { Store } from "@ngrx/store";
import {EMPTY,Observable,catchError,debounceTime,distinctUntilChanged,finalize,of,switchMap,tap,} from "rxjs";
import {ActivarLoadingAction, DesactivarLoadingAction,} from "src/app/@store/actions";
import { AppState } from "src/app/@store/app.reducers";
import { IResponseValidaContrasena, Validacion,} from "src/app/models/administracion-usuarios/administracion-usuarios.model";
import { INormaModelInput, IResponseModel,} from "src/app/models/seguros-atlas/atlas.model";
import { AdministrarUsuariosService } from "src/app/services/administracion-usuarios/administrar-usuarios.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { ModalImagenAyudaPolizaComponent } from "src/app/pages/clientes/@components/modal-imagen-ayuda-poliza/modal-imagen-ayuda-poliza.component";
import ValidationRegistro from "../../validators/registro.validators";
import { RegistroInformativoDialogComponent } from "../dialogs/registro-informativo-dialog/registro-informativo-dialog.component";
import { RegistroValidadorDosFaComponent } from "../dialogs/registro-validador-dos-fa/registro-validador-dos-fa.component";

interface CatalogoPregunta {
  Text: string;
  Value: string | number;
}

interface LadaTelefonicaInternacionalResponse {
  valor_dato: number | string;
  descripl_dato: string;
}

interface CodigoPaisTelefono {
  codigo: string;
  pais: string;
  bandera: string;
}

interface RegistroAseguradoResponse {
  claveUsuario?: string;
  ClaveUsuario?: string;
}

interface RegistroAseguradoRequest {
  Password: string;
  ConfirmaPassword: string;
  Email: string;
  CodEmail: string;
  Telefono: number;
  CodTelefono: string;
  Sucursal: string;
  Linea: number;
  Producto: number;
  Poliza: number;
  Certificado: number;
  Inciso: number;
  Seccion: number;
  Ubicacion: number;
  FechaInicioVigencia: string;
  AnioEmision: number;
  Alias: string;
  IdPregunta: number;
  Respuesta: string;
}

type ContactoControlName = "Email" | "Telefono";
type CampoPolizaCondicional =
  | "Inciso"
  | "Ubicacion"
  | "Certificado"
  | "Seccion";

@Component({
  selector: "app-registro-asegurado-form",
  standalone: true,
  templateUrl: "./registro-asegurado-form.component.html",
  styleUrls: ["./registro-asegurado-form.component.scss"],
  imports: [ReactiveFormsModule, MatIcon],
})
export class RegistroAseguradoFormComponent implements OnInit {
  @Output() readonly regresarPerfil = new EventEmitter<void>();
  @Output() readonly registroCompletado = new EventEmitter<string>();
  @Output() readonly formularioModificado = new EventEmitter<boolean>();

  private readonly inputLinea = viewChild<ElementRef<HTMLInputElement>>("inputLinea");
  private readonly inputProducto = viewChild<ElementRef<HTMLInputElement>>("inputProducto");
  private readonly inputPoliza = viewChild<ElementRef<HTMLInputElement>>("inputPoliza");
  private readonly inputFechaInicio = viewChild<ElementRef<HTMLInputElement>>("inputFechaInicio");

  readonly formularioAsegurado = new FormGroup(
    {
      Password: new FormControl("", {
        nonNullable: true,
        validators: Validators.required,
      }),
      ConfirmaPassword: new FormControl("", {
        nonNullable: true,
        validators: Validators.required,
      }),
      Alias: new FormControl("", {
        nonNullable: true,
        validators: Validators.required,
      }),
      Email: new FormControl("", {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/),
        ],
      }),
      Telefono: new FormControl("", {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(/^\d{11,15}$/)],
      }),
      CodEmail: new FormControl("", { nonNullable: true }),
      CodTelefono: new FormControl("", { nonNullable: true }),
      FechaInicioVigencia: new FormControl<string | null>(
        null,
        Validators.required,
      ),
      Sucursal: new FormControl("", {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(3),
          Validators.pattern(/^[a-zA-Z0-9]{3}$/),
        ],
      }),
      Linea: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.pattern(/^\d$/)],
      }),
      Producto: new FormControl("", {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(/^\d{1,3}$/)],
      }),
      Poliza: new FormControl("", {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(/^\d{1,8}$/)],
      }),
      Inciso: new FormControl<number | null>(null),
      Ubicacion: new FormControl<number | null>(null),
      Certificado: new FormControl<number | null>(null),
      Seccion: new FormControl<number | null>(null),
      IdPregunta: new FormControl<number | string | null>(
        null,
        Validators.required,
      ),
      Respuesta: new FormControl("", {
        nonNullable: true,
        validators: Validators.required,
      }),
    },
    {
      validators: ValidationRegistro.match("Password", "ConfirmaPassword"),
    },
  );

  hidePassword = true;
  hideConfirmPassword = true;

  validandoPassword = false;
  passwordValido = false;
  generaErrorPasswordForm = false;
  passwordValidaciones: string[] = [];

  validandoCorreo = false;
  validandoTelefono = false;
  dosFaCorreoHabilitado = true;
  dosFaTelefonoHabilitado = true;
  consultandoNormaCorreo = true;
  consultandoNormaTelefono = true;
  procesandoCorreo = false;
  procesandoTelefono = false;
  twoFaCorreoAbierto = false;
  twoFaTelefonoAbierto = false;
  loadingRegistro = false;

  emailValidado = "";
  telefonoValidado = "";

  catPreguntas: CatalogoPregunta[] = [];
  codigosPaisTelefono: CodigoPaisTelefono[] = [
    { codigo: "52", pais: "México", bandera: "MX" },
  ];
  codigoPaisTelefonoSeleccionado: CodigoPaisTelefono =
    this.codigosPaisTelefono[0];
  telefonoLocal = "";

  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store<AppState>);
  private confirmandoCambioCorreo = false;
  private confirmandoCambioTelefono = false;
  private normaCorreoConsultada = false;
  private normaTelefonoConsultada = false;
  private consultasNormasPendientes = 0;

  constructor(
    private readonly authService: AuthService,
    private readonly adminService: AdministrarUsuariosService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.cargarConfiguracionDosFa();
    this.configurarCamposPorLinea(null);
    this.configurarCambioLinea();
    this.configurarValidacionPassword();
    this.configurarSincronizacionConfirmacionPassword();
    this.configurarCambiosContacto();
    this.cargarCatalogoPreguntas();
    this.cargarLadasTelefonicasInternacionales();
    this.formularioAsegurado.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.formularioModificado.emit(this.formularioAsegurado.dirty);
      });
  }

  regresar(): void {
    this.regresarPerfil.emit();
  }

  private cargarConfiguracionDosFa(): void {
    this.consultasNormasPendientes = 2;
    this.store.dispatch(ActivarLoadingAction());

    this.consultarConfiguracionDosFaCorreo();
    this.consultarConfiguracionDosFaTelefono();
  }

  private finalizarCargaInicialNorma(): void {
    this.consultasNormasPendientes = Math.max(
      0,
      this.consultasNormasPendientes - 1,
    );

    if (this.consultasNormasPendientes === 0) {
      this.store.dispatch(DesactivarLoadingAction());
    }
  }

  private consultarConfiguracionDosFaCorreo(): void {
    this.consultandoNormaCorreo = true;

    this.authService
      .obtenerNormaAtlas(this.crearNorma(763))
      .pipe(
        finalize(() => {
          this.consultandoNormaCorreo = false;
          this.finalizarCargaInicialNorma();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (respuesta: IResponseModel) => {
          this.aplicarConfiguracionDosFaCorreo(respuesta);
        },
        error: () => {
          this.normaCorreoConsultada = false;
          this.dosFaCorreoHabilitado = true;
        },
      });
  }

  private consultarConfiguracionDosFaTelefono(): void {
    this.consultandoNormaTelefono = true;

    this.authService
      .obtenerNormaAtlas(this.crearNorma(765))
      .pipe(
        finalize(() => {
          this.consultandoNormaTelefono = false;
          this.finalizarCargaInicialNorma();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (respuesta: IResponseModel) => {
          this.aplicarConfiguracionDosFaTelefono(respuesta);
        },
        error: () => {
          this.normaTelefonoConsultada = false;
          this.dosFaTelefonoHabilitado = true;
        },
      });
  }

  private aplicarConfiguracionDosFaCorreo(
    respuesta: IResponseModel,
  ): void {
    this.normaCorreoConsultada = true;
    this.dosFaCorreoHabilitado = respuesta?.Respuesta?.Status == 1;

    if (!this.dosFaCorreoHabilitado) {
      this.formularioAsegurado.controls.CodEmail.setValue("9000");
      this.validandoCorreo = false;
      this.emailValidado = "";
      return;
    }

    if (this.formularioAsegurado.controls.CodEmail.value === "9000") {
      this.formularioAsegurado.controls.CodEmail.setValue("");
    }
  }

  private aplicarConfiguracionDosFaTelefono(
    respuesta: IResponseModel,
  ): void {
    this.normaTelefonoConsultada = true;
    this.dosFaTelefonoHabilitado = respuesta?.Respuesta?.Status == 1;

    if (!this.dosFaTelefonoHabilitado) {
      this.formularioAsegurado.controls.CodTelefono.setValue("9000");
      this.validandoTelefono = false;
      this.telefonoValidado = "";
      return;
    }

    if (this.formularioAsegurado.controls.CodTelefono.value === "9000") {
      this.formularioAsegurado.controls.CodTelefono.setValue("");
    }
  }

  continuar(): void {
    this.formularioAsegurado.markAllAsTouched();
    this.sincronizarTelefonoCompleto(true);
    this.sincronizarErrorConfirmaPassword();

    const errores = this.obtenerErroresRegistro();

    if (errores.length) {
      this.mostrarErroresRegistro(errores);
      return;
    }

    this.registrarAsegurado();
  }

  private configurarCambioLinea(): void {
    this.formularioAsegurado.controls.Linea.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((linea) => {
        this.configurarCamposPorLinea(linea);
      });
  }

  private configurarCamposPorLinea(linea: number | null): void {
    const campos: CampoPolizaCondicional[] = [
      "Inciso",
      "Ubicacion",
      "Certificado",
      "Seccion",
    ];

    campos.forEach((campo) => {
      const control = this.formularioAsegurado.controls[campo];
      control.clearValidators();
      control.reset(null, { emitEvent: false });
      control.disable({ emitEvent: false });
    });

    if (linea === 1) {
      this.habilitarCampoPoliza("Inciso");
    } else if (linea === 2) {
      this.habilitarCampoPoliza("Ubicacion");
    } else if (linea === 4) {
      // TODO negocio: el legacy exige Certificado, aunque ConsultaPolizaAgregar
      // usa num_incisok = 1 y no consume el valor capturado.
      this.habilitarCampoPoliza("Certificado");
    } else if ([3, 7, 8].includes(Number(linea))) {
      this.habilitarCampoPoliza("Certificado");
      this.habilitarCampoPoliza("Seccion");
    }
  }

  private habilitarCampoPoliza(campo: CampoPolizaCondicional): void {
    const control = this.formularioAsegurado.controls[campo];

    control.setValidators([Validators.required, Validators.min(0)]);
    control.enable({ emitEvent: false });
    control.updateValueAndValidity({ emitEvent: false });
  }

  mostrarCampoPoliza(campo: CampoPolizaCondicional): boolean {
    return this.formularioAsegurado.controls[campo].enabled;
  }

  private registrarAsegurado(): void {
    if (this.loadingRegistro) {
      return;
    }

    const payload = this.construirPayload();

    this.loadingRegistro = true;
    this.store.dispatch(ActivarLoadingAction());

    this.ejecutarRegistro(payload)
      .pipe(
        finalize(() => {
          this.loadingRegistro = false;
          this.store.dispatch(DesactivarLoadingAction());
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (respuesta: RegistroAseguradoResponse) => {
          const claveUsuario = `${
            respuesta?.claveUsuario ?? respuesta?.ClaveUsuario ?? ""
          }`.trim();

          if (!claveUsuario) {
            this.abrirDialogoInformativo(
              "warning",
              "Registro procesado",
              "El registro fue procesado, pero no fue posible recuperar la clave del usuario.",
            );
            return;
          }

          this.registroCompletado.emit(claveUsuario);
        },
        error: (error) => {
          this.abrirErrorRegistro(error);
        },
      });
  }

  private ejecutarRegistro(
    payload: RegistroAseguradoRequest,
  ): Observable<RegistroAseguradoResponse> {
    return this.authService.registroUsuario(
      payload as any,
    ) as Observable<RegistroAseguradoResponse>;
  }

  private construirPayload(): RegistroAseguradoRequest {
    const raw = this.formularioAsegurado.getRawValue();
    const linea = Number(raw.Linea);

    return {
      Password: `${raw.Password || ""}`,
      ConfirmaPassword: `${raw.ConfirmaPassword || ""}`,
      Email: `${raw.Email || ""}`.trim(),
      CodEmail: `${raw.CodEmail || ""}`,
      Telefono: Number(raw.Telefono),
      CodTelefono: `${raw.CodTelefono || ""}`,
      Sucursal: `${raw.Sucursal || ""}`.trim().toUpperCase(),
      Linea: linea,
      Producto: Number(raw.Producto),
      Poliza: Number(raw.Poliza),
      Inciso: linea === 1 ? Number(raw.Inciso) : 0,
      Ubicacion: linea === 2 ? Number(raw.Ubicacion) : 0,
      Certificado: [3, 4, 7, 8].includes(linea) ? Number(raw.Certificado) : 0,
      Seccion: [3, 7, 8].includes(linea) ? Number(raw.Seccion) : 0,
      FechaInicioVigencia: `${raw.FechaInicioVigencia || ""}`,
      // TODO negocio: el frontend legacy siempre envía cero. Confirmar si para
      // línea 4 debe capturarse el año de emisión.
      AnioEmision: 0,
      Alias: `${raw.Alias || ""}`.trim(),
      IdPregunta: Number(raw.IdPregunta),
      Respuesta: `${raw.Respuesta || ""}`.trim(),
    };
  }

  private obtenerErroresRegistro(): string[] {
    const errores = this.obtenerErroresFormulario();

    if (this.validandoPassword) {
      errores.push("Contraseña: La validación aún está en proceso.");
    }

    if (
      this.formularioAsegurado.controls.Password.value &&
      (this.generaErrorPasswordForm || !this.passwordValido)
    ) {
      errores.push("Contraseña: La contraseña tiene un formato incorrecto.");
    }

    if (this.consultandoNormaCorreo) {
      errores.push(
        "Email: La configuración de verificación aún está en proceso.",
      );
    } else if (this.dosFaCorreoHabilitado && !this.validandoCorreo) {
      errores.push("Email: El correo electrónico no está validado.");
    }

    if (this.consultandoNormaTelefono) {
      errores.push(
        "Teléfono celular: La configuración de verificación aún está en proceso.",
      );
    } else if (this.dosFaTelefonoHabilitado && !this.validandoTelefono) {
      errores.push("Teléfono celular: El teléfono no está validado.");
    }

    return [...new Set(errores)];
  }

  private obtenerErroresFormulario(): string[] {
    const errores: string[] = [];

    Object.keys(this.formularioAsegurado.controls).forEach((controlName) => {
      if (["CodEmail", "CodTelefono"].includes(controlName)) {
        return;
      }

      const control = this.getControl(controlName);

      if (!control || control.disabled || !control.errors) {
        return;
      }

      errores.push(
        `${this.obtenerEtiquetaControl(controlName)}: ${this.obtenerMensajeErrorControl(controlName)}`,
      );
    });

    return errores;
  }

  private mostrarErroresRegistro(errores: string[]): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: "520px",
      maxWidth: "calc(100vw - 32px)",
      autoFocus: false,
      data: {
        type: "error",
        icon: "error_outline",
        title: "Revisa la información",
        message: "No fue posible continuar. Corrige lo siguiente:",
        messages: errores,
        actionText: "Entendido",
      },
    });
  }

  private abrirErrorRegistro(error: any): void {
    const errores = this.normalizarErroresBackend(error);
    const esCuentaExistente = errores.some((item) => item.key === "Email");

    this.dialog.open(RegistroInformativoDialogComponent, {
      width: "520px",
      maxWidth: "calc(100vw - 32px)",
      autoFocus: false,
      data: {
        type: esCuentaExistente ? "warning" : "error",
        icon: esCuentaExistente ? "info" : "error_outline",
        title: esCuentaExistente
          ? "Cuenta previamente registrada"
          : "Error al registrar",
        message: esCuentaExistente
          ? "El backend encontró una cuenta asociada al correo proporcionado."
          : "No fue posible completar el registro.",
        messages: errores.length
          ? errores.map((item) => item.message)
          : ["Intenta nuevamente más tarde."],
        actionText: "Entendido",
      },
    });
  }

  private normalizarErroresBackend(
    error: any,
  ): Array<{ key: string; message: string }> {
    const body = error?.error;

    if (Array.isArray(body)) {
      return body
        .map((item) => ({
          key: `${item?.Key || item?.key || ""}`,
          message:
            `${item?.Exception || item?.Message || item?.message || ""}`.trim(),
        }))
        .filter((item) => !!item.message);
    }

    const mensaje =
      body?.Message ||
      body?.Exception ||
      (typeof body === "string" ? body : "") ||
      "No fue posible registrar al asegurado.";

    return [{ key: "", message: `${mensaje}` }];
  }

  private configurarValidacionPassword(): void {
    const passwordControl = this.formularioAsegurado.controls.Password;

    passwordControl.valueChanges
      .pipe(
        tap(() => {
          this.validandoPassword = true;
          this.passwordValido = false;
        }),
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((password) => {
          if (!`${password || ""}`.trim()) {
            this.reiniciarValidacionesContrasena();
            return EMPTY;
          }

          return this.adminService
            .postValidaContrasena({
              password,
              usuario: "",
            })
            .pipe(
              catchError((error) =>
                of({
                  error,
                  datos: null,
                }),
              ),
            );
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((respuesta: any) => {
        if (respuesta?.error) {
          this.procesarErrorValidacionPassword(respuesta.error);
          return;
        }

        this.procesarRespuestaValidacionPassword(
          respuesta as IResponseValidaContrasena,
        );
      });
  }

  private procesarRespuestaValidacionPassword(
    respuesta: IResponseValidaContrasena,
  ): void {
    const control = this.formularioAsegurado.controls.Password;
    this.validandoPassword = false;

    if (respuesta?.datos?.length) {
      this.generaErrorPasswordForm = true;
      this.passwordValido = false;
      this.passwordValidaciones = this.normalizarMensajesPassword(
        respuesta.datos,
      );
      control.setErrors({
        ...(control.errors || {}),
        formatoIncorrecto: true,
      });
      this.sincronizarErrorConfirmaPassword();
      return;
    }

    this.generaErrorPasswordForm = false;
    this.passwordValido = true;
    this.passwordValidaciones = [];
    this.limpiarErroresControl(control, ["formatoIncorrecto"]);
    this.sincronizarErrorConfirmaPassword();
  }

  private procesarErrorValidacionPassword(error: any): void {
    const control = this.formularioAsegurado.controls.Password;

    this.validandoPassword = false;
    this.passwordValido = false;
    this.generaErrorPasswordForm = true;
    this.passwordValidaciones = this.normalizarMensajesPassword(error?.error);

    if (!this.passwordValidaciones.length) {
      this.passwordValidaciones = [
        "No fue posible comprobar el formato de la contraseña.",
      ];
    }

    control.setErrors({
      ...(control.errors || {}),
      formatoIncorrecto: true,
    });
    this.sincronizarErrorConfirmaPassword();
  }

  private configurarSincronizacionConfirmacionPassword(): void {
    this.formularioAsegurado.controls.Password.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.sincronizarErrorConfirmaPassword());

    this.formularioAsegurado.controls.ConfirmaPassword.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.sincronizarErrorConfirmaPassword());
  }

  private sincronizarErrorConfirmaPassword(): void {
    const password = this.formularioAsegurado.controls.Password.value;
    const confirmaControl = this.formularioAsegurado.controls.ConfirmaPassword;
    const confirma = confirmaControl.value;

    if (!confirma) {
      this.limpiarErroresControl(confirmaControl, ["match"]);
      return;
    }

    if (password !== confirma) {
      confirmaControl.setErrors({
        ...(confirmaControl.errors || {}),
        match: true,
      });
      return;
    }

    this.limpiarErroresControl(confirmaControl, ["match"]);
  }

  abrirErroresPassword(): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: "440px",
      maxWidth: "calc(100vw - 32px)",
      autoFocus: false,
      data: {
        type: "warning",
        icon: "error_outline",
        title: "Revisa tu contraseña",
        message: "La contraseña debe cumplir con las siguientes condiciones:",
        messages: this.passwordValidaciones.length
          ? this.passwordValidaciones
          : ["No fue posible obtener el detalle de las reglas."],
        actionText: "Entendido",
      },
    });
  }

  mostrarIconoPasswordError(): boolean {
    const control = this.formularioAsegurado.controls.Password;
    return (
      control.hasError("formatoIncorrecto") &&
      (control.touched || control.dirty)
    );
  }

  mostrarIconoPasswordCorrecto(): boolean {
    const control = this.formularioAsegurado.controls.Password;

    return (
      !!control.value &&
      control.valid &&
      this.passwordValido &&
      !this.validandoPassword &&
      !this.generaErrorPasswordForm
    );
  }

  mostrarIconoConfirmaPasswordCorrecto(): boolean {
    const password = this.formularioAsegurado.controls.Password.value;
    const confirmaControl = this.formularioAsegurado.controls.ConfirmaPassword;

    return (
      !!password &&
      !!confirmaControl.value &&
      password === confirmaControl.value &&
      this.passwordValido &&
      !this.validandoPassword &&
      !confirmaControl.errors
    );
  }

  private reiniciarValidacionesContrasena(): void {
    this.validandoPassword = false;
    this.passwordValido = false;
    this.generaErrorPasswordForm = false;
    this.passwordValidaciones = [];
    this.limpiarErroresControl(this.formularioAsegurado.controls.Password, [
      "formatoIncorrecto",
    ]);
  }

  private normalizarMensajesPassword(validaciones: any): string[] {
    if (!validaciones) {
      return [];
    }

    const elementos = Array.isArray(validaciones)
      ? validaciones
      : [validaciones];

    return elementos
      .map((item: Validacion | any) => {
        if (typeof item === "string") {
          return item;
        }

        return (
          item?.Descripcion ||
          item?.descripcion ||
          item?.Exception ||
          item?.Message ||
          item?.message ||
          item?.password?.[0] ||
          ""
        );
      })
      .map((mensaje: string) => `${mensaje}`.trim())
      .filter(Boolean);
  }

  verificarCorreoAlPerderFoco(): void {
    const control = this.formularioAsegurado.controls.Email;
    control.markAsTouched();

    if (!this.dosFaCorreoHabilitado || this.consultandoNormaCorreo) {
      return;
    }

    if (!this.validandoCorreo && !this.procesandoCorreo && control.valid) {
      this.verificarCorreo();
    }
  }

  verificarCorreo(): void {
    const control = this.formularioAsegurado.controls.Email;
    control.markAsTouched();

    if (
      !this.dosFaCorreoHabilitado ||
      this.consultandoNormaCorreo ||
      control.invalid ||
      this.validandoCorreo ||
      this.procesandoCorreo ||
      this.twoFaCorreoAbierto
    ) {
      return;
    }

    if (this.normaCorreoConsultada) {
      this.abrirValidadorDosFaCorreo();
      return;
    }

    this.procesandoCorreo = true;
    this.store.dispatch(ActivarLoadingAction());

    this.authService
      .obtenerNormaAtlas(this.crearNorma(763))
      .pipe(
        finalize(() => {
          this.procesandoCorreo = false;
          this.store.dispatch(DesactivarLoadingAction());
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (respuesta: IResponseModel) => {
          this.aplicarConfiguracionDosFaCorreo(respuesta);

          if (this.dosFaCorreoHabilitado) {
            this.abrirValidadorDosFaCorreo();
          }
        },
        error: () => {
          this.normaCorreoConsultada = false;
          this.dosFaCorreoHabilitado = true;
          this.reiniciarValidacionCorreo();
          this.mostrarErrorSolicitudCodigo();
        },
      });
  }

  verificarTelefonoAlPerderFoco(): void {
    this.sincronizarTelefonoCompleto(true);

    if (!this.dosFaTelefonoHabilitado || this.consultandoNormaTelefono) {
      return;
    }

    if (this.telefonoTieneFormatoCorrecto()) {
      this.verificarTelefono();
    }
  }

  verificarTelefono(): void {
    const control = this.formularioAsegurado.controls.Telefono;
    control.markAsTouched();

    if (
      !this.dosFaTelefonoHabilitado ||
      this.consultandoNormaTelefono ||
      !this.telefonoTieneFormatoCorrecto() ||
      this.validandoTelefono ||
      this.procesandoTelefono ||
      this.twoFaTelefonoAbierto
    ) {
      return;
    }

    if (this.normaTelefonoConsultada) {
      this.abrirValidadorDosFaTelefono();
      return;
    }

    this.procesandoTelefono = true;
    this.store.dispatch(ActivarLoadingAction());

    this.authService
      .obtenerNormaAtlas(this.crearNorma(765))
      .pipe(
        finalize(() => {
          this.procesandoTelefono = false;
          this.store.dispatch(DesactivarLoadingAction());
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (respuesta: IResponseModel) => {
          this.aplicarConfiguracionDosFaTelefono(respuesta);

          if (this.dosFaTelefonoHabilitado) {
            this.abrirValidadorDosFaTelefono();
          }
        },
        error: () => {
          this.normaTelefonoConsultada = false;
          this.dosFaTelefonoHabilitado = true;
          this.reiniciarValidacionTelefono();
          this.mostrarErrorSolicitudCodigo();
        },
      });
  }

  private crearNorma(numero: number): INormaModelInput {
    return {
      NumNorma: numero,
      Parametro1: 1,
      Parametro2: 0,
      Parametro3: 0,
    };
  }

  private abrirValidadorDosFaCorreo(): void {
    if (this.twoFaCorreoAbierto) {
      return;
    }

    this.twoFaCorreoAbierto = true;
    const config: MatDialogConfig = this.crearConfiguracionDosFa(
      "Correo Electronico",
      this.formularioAsegurado.controls.Email.value,
    );

    this.dialog
      .open(RegistroValidadorDosFaComponent, config)
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.twoFaCorreoAbierto = false;
        const codigo = `${result?.TwoFactorCode || ""}`;

        if (codigo) {
          this.marcarCorreoValidado(codigo);
          return;
        }

        this.reiniciarValidacionCorreo();
      });
  }

  private abrirValidadorDosFaTelefono(): void {
    if (this.twoFaTelefonoAbierto) {
      return;
    }

    this.twoFaTelefonoAbierto = true;
    const config: MatDialogConfig = this.crearConfiguracionDosFa(
      "Telefono",
      this.formularioAsegurado.controls.Telefono.value,
    );

    this.dialog
      .open(RegistroValidadorDosFaComponent, config)
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.twoFaTelefonoAbierto = false;
        const codigo = `${result?.TwoFactorCode || ""}`;

        if (codigo) {
          this.marcarTelefonoValidado(codigo);
          return;
        }

        this.reiniciarValidacionTelefono();
      });
  }

  private crearConfiguracionDosFa(
    tipo: string,
    valor: string,
  ): MatDialogConfig {
    return {
      autoFocus: false,
      disableClose: true,
      width: "520px",
      maxWidth: "calc(100vw - 32px)",
      panelClass: "registro-twofa-dialog-panel",
      data: {
        tipo,
        valor,
        usuario: "",
      },
    };
  }

  private marcarCorreoValidado(codigo: string): void {
    this.formularioAsegurado.controls.CodEmail.setValue(codigo);
    this.validandoCorreo = true;
    this.emailValidado = this.formularioAsegurado.controls.Email.value;
  }

  private marcarTelefonoValidado(codigo: string): void {
    this.formularioAsegurado.controls.CodTelefono.setValue(codigo);
    this.validandoTelefono = true;
    this.telefonoValidado = this.formularioAsegurado.controls.Telefono.value;
    this.sincronizarTelefonoVisualDesdeCompleto(this.telefonoValidado);
  }

  private reiniciarValidacionCorreo(): void {
    this.formularioAsegurado.controls.CodEmail.setValue(
      this.dosFaCorreoHabilitado ? "" : "9000",
    );
    this.validandoCorreo = false;
    this.emailValidado = "";
  }

  private reiniciarValidacionTelefono(): void {
    this.formularioAsegurado.controls.CodTelefono.setValue(
      this.dosFaTelefonoHabilitado ? "" : "9000",
    );
    this.validandoTelefono = false;
    this.telefonoValidado = "";
  }

  private configurarCambiosContacto(): void {
    this.formularioAsegurado.controls.Email.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((email) => {
        if (
          this.validandoCorreo &&
          !this.confirmandoCambioCorreo &&
          email !== this.emailValidado
        ) {
          this.confirmarCambioCorreo(email);
        }
      });

    this.formularioAsegurado.controls.Telefono.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((telefono) => {
        if (
          this.validandoTelefono &&
          !this.confirmandoCambioTelefono &&
          telefono !== this.telefonoValidado
        ) {
          this.confirmarCambioTelefono(telefono);
        }
      });
  }

  private confirmarCambioCorreo(_nuevoCorreo: string): void {
    this.confirmandoCambioCorreo = true;
    this.abrirConfirmacionCambio(
      "Cambiar email",
      "Si cambias el email tendrás que validarlo nuevamente. ¿Deseas continuar?",
    ).subscribe((confirmado) => {
      this.confirmandoCambioCorreo = false;

      if (confirmado) {
        this.reiniciarValidacionCorreo();
        return;
      }

      this.formularioAsegurado.controls.Email.setValue(this.emailValidado, {
        emitEvent: false,
      });
    });
  }

  private confirmarCambioTelefono(_nuevoTelefono: string): void {
    this.confirmandoCambioTelefono = true;
    this.abrirConfirmacionCambio(
      "Cambiar teléfono",
      "Si cambias el teléfono tendrás que validarlo nuevamente. ¿Deseas continuar?",
    ).subscribe((confirmado) => {
      this.confirmandoCambioTelefono = false;

      if (confirmado) {
        this.reiniciarValidacionTelefono();
        return;
      }

      this.sincronizarTelefonoVisualDesdeCompleto(this.telefonoValidado);
      this.formularioAsegurado.controls.Telefono.setValue(
        this.telefonoValidado,
        {
          emitEvent: false,
        },
      );
    });
  }

  private abrirConfirmacionCambio(
    title: string,
    message: string,
  ): Observable<boolean> {
    return this.dialog
      .open(RegistroInformativoDialogComponent, {
        width: "440px",
        maxWidth: "calc(100vw - 32px)",
        autoFocus: false,
        data: {
          type: "warning",
          icon: "error_outline",
          title,
          message,
          showCancelButton: true,
          confirmText: "Continuar",
          cancelText: "Cancelar",
        },
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef));
  }

  telefonoTieneFormatoCorrecto(): boolean {
    const control = this.formularioAsegurado.controls.Telefono;

    return (
      this.telefonoLocal.length === 10 &&
      !!this.codigoPaisTelefonoSeleccionado?.codigo &&
      control.valid
    );
  }

  telefonoPuedeVerificarse(): boolean {
    return (
      this.dosFaTelefonoHabilitado &&
      !this.consultandoNormaTelefono &&
      this.telefonoTieneFormatoCorrecto() &&
      !this.validandoTelefono &&
      !this.procesandoTelefono
    );
  }

  seleccionarCodigoPaisTelefono(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const codigo = this.codigosPaisTelefono.find(
      (item) => this.getCodigoPaisTelefonoKey(item) === select.value,
    );

    if (!codigo) {
      return;
    }

    this.codigoPaisTelefonoSeleccionado = codigo;
    this.sincronizarTelefonoCompleto(true);
  }

  capturarTelefonoLocal(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value.replace(/\D/g, "").slice(0, 10);

    input.value = valor;
    this.telefonoLocal = valor;
    this.sincronizarTelefonoCompleto(true);
  }

  private sincronizarTelefonoCompleto(marcar = false): void {
    const control = this.formularioAsegurado.controls.Telefono;
    const telefono = this.telefonoLocal
      ? `${this.codigoPaisTelefonoSeleccionado.codigo}${this.telefonoLocal}`
      : "";

    control.setValue(telefono);

    if (marcar) {
      control.markAsDirty();
      control.markAsTouched();
    }

    control.updateValueAndValidity({ emitEvent: false });

    if (marcar && this.telefonoLocal && this.telefonoLocal.length !== 10) {
      control.setErrors({
        ...(control.errors || {}),
        telefonoLocalIncompleto: true,
      });
    }
  }

  private sincronizarTelefonoVisualDesdeCompleto(telefono: string): void {
    const valor = `${telefono || ""}`.replace(/\D/g, "");
    const codigo = [...this.codigosPaisTelefono]
      .sort((a, b) => b.codigo.length - a.codigo.length)
      .find((item) => valor.startsWith(item.codigo));

    this.codigoPaisTelefonoSeleccionado = codigo || this.codigosPaisTelefono[0];
    this.telefonoLocal = valor
      .slice(this.codigoPaisTelefonoSeleccionado.codigo.length)
      .slice(0, 10);
  }

  private cargarCatalogoPreguntas(): void {
    this.authService
      .catalogoPreguntas()
      .pipe(
        catchError(() => of([])),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((respuesta) => {
        this.catPreguntas = Array.isArray(respuesta)
          ? (respuesta as CatalogoPregunta[])
          : [];
      });
  }

  private cargarLadasTelefonicasInternacionales(): void {
    this.authService
      .obtenerLadasTelefonicasInternacionales()
      .pipe(
        catchError(() => of(null)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((respuesta: any) => {
        const datos = Array.isArray(respuesta?.Respuesta)
          ? respuesta.Respuesta
          : [];

        const ladas = datos
          .filter(
            (item: LadaTelefonicaInternacionalResponse) =>
              item?.valor_dato !== null &&
              item?.valor_dato !== undefined &&
              !!item?.descripl_dato,
          )
          .map((item: LadaTelefonicaInternacionalResponse) => ({
            codigo: `${item.valor_dato}`.trim(),
            pais: `${item.descripl_dato}`.trim(),
            bandera: this.obtenerClavePais(`${item.descripl_dato}`),
          }));

        if (ladas.length) {
          this.codigosPaisTelefono = this.ordenarLadas(ladas);
        }

        const mexico = this.codigosPaisTelefono.find(
          (item) =>
            item.codigo === "52" ||
            this.normalizarTexto(item.pais) === "mexico",
        );

        this.codigoPaisTelefonoSeleccionado =
          mexico || this.codigosPaisTelefono[0];
        this.sincronizarTelefonoCompleto(false);
      });
  }

  private ordenarLadas(ladas: CodigoPaisTelefono[]): CodigoPaisTelefono[] {
    return [...ladas].sort((a, b) => {
      if (a.codigo === "52") {
        return -1;
      }

      if (b.codigo === "52") {
        return 1;
      }

      return this.normalizarTexto(a.pais).localeCompare(
        this.normalizarTexto(b.pais),
      );
    });
  }

  capturarSucursal(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 3)
      .toUpperCase();

    input.value = valor;
    const control = this.formularioAsegurado.controls.Sucursal;
    control.setValue(valor);

    if (valor.length === 3 && control.valid) {
      this.enfocarInput(this.inputLinea());
    }
  }

  capturarLinea(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value.replace(/\D/g, "").slice(0, 1);
    const control = this.formularioAsegurado.controls.Linea;

    input.value = valor;
    control.setValue(valor ? Number(valor) : null);
    control.markAsDirty();

    if (valor.length === 1 && control.valid) {
      this.enfocarInput(this.inputProducto());
    }
  }

  capturarNumerico(
    event: Event,
    controlName: "Producto" | "Poliza",
    longitud: number,
  ): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value.replace(/\D/g, "").slice(0, longitud);
    const control = this.formularioAsegurado.controls[controlName];

    input.value = valor;
    control.setValue(valor);

    if (valor.length !== longitud || control.invalid) {
      return;
    }

    if (controlName === "Producto") {
      this.enfocarInput(this.inputPoliza());
      return;
    }

    this.enfocarInput(this.inputFechaInicio());
  }

  private enfocarInput(
    input: ElementRef<HTMLInputElement> | undefined,
  ): void {
    input?.nativeElement.focus();
  }

  abrirAyudaPoliza(): void {
    this.dialog.open(ModalImagenAyudaPolizaComponent, {
      maxWidth: "calc(100vw - 32px)",
      data: {
        urlImage: this.imagenAyudaPoliza,
      },
    });
  }

  get imagenAyudaPoliza(): string {
    const linea = Number(this.formularioAsegurado.controls.Linea.value);
    const producto = Number(this.formularioAsegurado.controls.Producto.value);

    if (linea === 1 && producto === 24) {
      return "assets/img/ejemplos-poliza/FlotillaAutos.jpg";
    }

    if (linea === 3 && producto === 3) {
      return "assets/img/ejemplos-poliza/GrupoGastosMedicosMayores.jpg";
    }

    if (linea === 8 && producto === 11) {
      return "assets/img/ejemplos-poliza/ColectivoAccidentesPersonales.jpg";
    }

    const imagenes: Record<number, string> = {
      1: "assets/img/ejemplos-poliza/IndividualAutos.jpg",
      2: "assets/img/ejemplos-poliza/IndividualDanos.jpg",
      3: "assets/img/ejemplos-poliza/IndividualGastosMedicosMayores.jpg",
      4: "assets/img/ejemplos-poliza/IndividualVidaIndividual.jpg",
      7: "assets/img/ejemplos-poliza/GrupoVidaGrupo.jpg",
      8: "assets/img/ejemplos-poliza/IndividualAccidentesPersonales.jpg",
    };

    return (
      imagenes[linea] ||
      "assets/img/ejemplos-poliza/ColectivoAccidentesPersonales.jpg"
    );
  }

  abrirInfoAlias(): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: "720px",
      maxWidth: "calc(100vw - 32px)",
      autoFocus: false,
      data: {
        type: "info",
        icon: "info",
        title: "Alias o sobrenombre",
        message:
          "El alias es el nombre con el que identificarás esta póliza dentro del portal.",
        actionText: "Entendido",
      },
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.getControl(controlName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }

  getError(controlName: string): string {
    const control = this.getControl(controlName);

    if (!control || !control.errors || !(control.touched || control.dirty)) {
      return "";
    }

    return this.obtenerMensajeErrorControl(controlName);
  }

  abrirErrorCampo(controlName: string): void {
    this.abrirDialogoInformativo(
      "error",
      `${this.obtenerEtiquetaControl(controlName)} no válido`,
      this.obtenerMensajeErrorControl(controlName),
    );
  }

  private obtenerMensajeErrorControl(controlName: string): string {
    const control = this.getControl(controlName);

    if (!control?.errors) {
      return "El campo no es válido.";
    }

    if (control.hasError("required")) {
      return "El campo es obligatorio.";
    }

    if (control.hasError("match")) {
      return "Las contraseñas no coinciden.";
    }

    if (control.hasError("formatoIncorrecto")) {
      return "La contraseña tiene un formato incorrecto.";
    }

    if (control.hasError("telefonoLocalIncompleto")) {
      return "Ingresa los 10 dígitos del teléfono.";
    }

    if (control.hasError("email")) {
      return "El correo no tiene un formato válido.";
    }

    if (control.hasError("minlength")) {
      return "El valor es demasiado corto.";
    }

    if (control.hasError("maxlength")) {
      return "El valor excede la longitud permitida.";
    }

    if (control.hasError("min")) {
      return "El valor no puede ser negativo.";
    }

    if (control.hasError("pattern")) {
      return this.obtenerErrorPattern(controlName);
    }

    return "El campo no es válido.";
  }

  private obtenerErrorPattern(controlName: string): string {
    const mensajes: Record<string, string> = {
      Email: "El correo no tiene un formato válido.",
      Telefono: "Ingresa los 10 dígitos del teléfono.",
      Sucursal: "Ingresa tres caracteres alfanuméricos.",
      Linea: "Ingresa una línea numérica de un dígito.",
      Producto: "Ingresa un producto numérico de hasta tres dígitos.",
      Poliza: "Ingresa una póliza numérica de hasta ocho dígitos.",
    };

    return mensajes[controlName] || "El formato no es válido.";
  }

  private obtenerEtiquetaControl(controlName: string): string {
    const etiquetas: Record<string, string> = {
      Password: "Contraseña",
      ConfirmaPassword: "Confirma contraseña",
      Alias: "Alias o sobrenombre",
      Email: "Email",
      Telefono: "Teléfono celular",
      FechaInicioVigencia: "Inicio de vigencia",
      Sucursal: "Sucursal",
      Linea: "Línea",
      Producto: "Producto",
      Poliza: "Póliza",
      Inciso: "Inciso",
      Ubicacion: "Ubicación",
      Certificado: "Certificado",
      Seccion: "Sección",
      IdPregunta: "Pregunta secreta",
      Respuesta: "Respuesta",
    };

    return etiquetas[controlName] || controlName;
  }

  private getControl(controlName: string): AbstractControl | null {
    return this.formularioAsegurado.get(controlName);
  }

  private limpiarErroresControl(
    control: AbstractControl,
    errores: string[],
  ): void {
    if (!control.errors) {
      return;
    }

    const erroresActuales = { ...control.errors };
    errores.forEach((error) => delete erroresActuales[error]);

    control.setErrors(
      Object.keys(erroresActuales).length ? erroresActuales : null,
    );
  }

  private mostrarErrorSolicitudCodigo(): void {
    this.abrirDialogoInformativo(
      "error",
      "No fue posible enviar el código",
      "Intenta solicitar tu código más tarde.",
    );
  }

  private abrirDialogoInformativo(
    type: "info" | "warning" | "error" | "success",
    title: string,
    message: string,
  ): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: "440px",
      maxWidth: "calc(100vw - 32px)",
      autoFocus: false,
      data: {
        type,
        title,
        message,
        actionText: "Aceptar",
      },
    });
  }

  desbloquearAutofill(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    setTimeout(() => (input.readOnly = false), 80);
  }

  bloquearAutofill(event: FocusEvent): void {
    (event.target as HTMLInputElement).readOnly = true;
  }

  private obtenerClavePais(pais: string): string {
    const claves: Record<string, string> = {
      mexico: "MX",
      "estados unidos": "US",
      canada: "CA",
      brasil: "BR",
      argentina: "AR",
      colombia: "CO",
      chile: "CL",
      peru: "PE",
      espana: "ES",
      francia: "FR",
      alemania: "DE",
      italia: "IT",
      "reino unido": "GB",
      china: "CN",
      japon: "JP",
      india: "IN",
      australia: "AU",
    };

    return (
      claves[this.normalizarTexto(pais)] ||
      `${pais || ""}`.trim().slice(0, 2).toUpperCase()
    );
  }

  private normalizarTexto(valor: string): string {
    return `${valor || ""}`
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  get codigoPaisTelefonoSeleccionadoKey(): string {
    return this.getCodigoPaisTelefonoKey(this.codigoPaisTelefonoSeleccionado);
  }

  getCodigoPaisTelefonoKey(pais: CodigoPaisTelefono): string {
    return pais ? `${pais.codigo}|${this.normalizarTexto(pais.pais)}` : "";
  }
}
